// 组件对象，大写
import panguTable from './panguTable.vue'
export default panguTable
